import { View, StyleSheet } from 'react-native';
import React from 'react';
import Typography from '../../typography/Typography';
import { ColorTokens, FontFamilyTokens, FontSizeTokens } from '@voltmoney/schema';
import * as Animatable from 'react-native-animatable';
const SubHeading = ({ label }) => {
    return (React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000 },
        React.createElement(View, { style: styles.textContainer },
            React.createElement(Typography, { label: label, fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 }))));
};
export default SubHeading;
const styles = StyleSheet.create({
    textContainer: {
        marginLeft: 16,
        marginTop: 24,
    },
});
